import {
  fetchorderDatas,
  fetchorderInfo,
  orderPay
} from '@/services/account'
export default {
  namespaced: true,
  state: {
    loadingDetails: false,
    decorators: {
    },
    orderListDatas: [],
    listType: 3
  },
  mutations: {
    setLoadingDetails (state, type) {
      state.loadingDetails = type
    },
    setOrderListDatas (state, datas) {
      state.orderListDatas = datas
    },
    setListType (state, type) {
      state.listType = type
    }
  },
  getters: {
    currentData (state) {
      const { orderListDatas } = state
      orderListDatas.forEach(item => {
        item['key'] = item.id
      })
      return orderListDatas
    }
  },
  actions: {
    async fetchOrderListDatas ({ commit }) {
      commit('setLoadingDetails', true)
      const chain = await fetchorderDatas()
        .onSuccess((raw) => {
          commit('setOrderListDatas', raw)
        })
        .onNetComplete(() => {
          commit('setLoadingDetails', false)
        })
        .config({ tip: false })
      return chain
    },
    async fetchOrderInfo ({ commit, dispatch }) {
      const chain = await fetchorderInfo()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async fetchPay ({ commit, dispatch }) {
      const chain = await orderPay()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    }
  }
}
